// extracted by mini-css-extract-plugin
export default {"routineList":"routineList-QqTpW","estimatedTime":"estimatedTime-ejooi","empty":"empty-GjeQw","bigMessage":"bigMessage-l0lyN"};